import type {FC} from 'react';

import {useI18n} from '@yourcoach/i18n';

import type {Props} from './types';

import * as S from './styles';

export const RecurringEventDisclaimer: FC<Props> = ({eventType}) => {
  const {t} = useI18n();

  const RULES = new Array(2).fill('').map((_, i) =>
    /**
     * @i18n_parser
     *
     * t('shared:CRUCalendarEvent.recurring_disclaimer.conference.rule_1')
     * t('shared:CRUCalendarEvent.recurring_disclaimer.conference.rule_2')
     * t('shared:CRUCalendarEvent.recurring_disclaimer.task.rule_1')
     * t('shared:CRUCalendarEvent.recurring_disclaimer.task.rule_2')
     */
    t(
      `shared:CRUCalendarEvent.recurring_disclaimer.${eventType}.rule_${i + 1}`,
    ),
  );

  return (
    <S.Container>
      <S.Title>
        {
          /**
           * @i18n_parser
           *
           * t('shared:CRUCalendarEvent.recurring_disclaimer.conference.header')
           * t('shared:CRUCalendarEvent.recurring_disclaimer.task.header')
           */
          t(`shared:CRUCalendarEvent.recurring_disclaimer.${eventType}.header`)
        }
      </S.Title>
      {RULES.map((rule, i) => (
        <S.RuleContainer key={i}>
          <S.Bullet />
          <S.RuleText>{rule}</S.RuleText>
        </S.RuleContainer>
      ))}
    </S.Container>
  );
};
